import React from 'react';
import styles from './index.module.scss';
import Overview from './components/Overview';
import OptimizeEngine from './components/OptimizeEngine';

const CenterBox = () => {
  return (
    <div className={styles.wrapper}>
      <Overview />
      <OptimizeEngine />
    </div>
  );
};

export default CenterBox;
